import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { CMButton } from '../Button/Button';
import { Box } from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';


function CMModel(props: any) {
   const ModelBodyComponent = props.modelCmpnt;
   console.log({props},"props");
  return (
    <div>
      <Modal isOpen={props.open} toggle={props.close} {...props} size='lg'>
        <ModalHeader toggle={props.close}><b>{props.ViewHeader}</b></ModalHeader>
        <ModalBody>

          <ModelBodyComponent rows={props.rows} columns={props.columns} noswitch={props.noswitch} closemodal={props?.close}/>

        </ModalBody>
        <ModalFooter>
          {props.buttons?.length ? props.buttons.map((btn: any) => (
            <Box component="span" sx={{ marginLeft: "16px" }}>
             <CMButton variant={btn.variant} value={btn.title} color={btn.color} onClick={(e:any)=>btn.onClick(props.rows,props.close,btn.value)} />
            </Box>
          )):""}
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default CMModel;